import React from 'react';

import { DepositsTableBodyProps } from '@epi-models/pages/Reports';

import { DepositsTableRow } from '../DepositsTableRow';

export const DepositsTableBody = ({ deposits }: DepositsTableBodyProps) => {
  return (
    <>
      {deposits.map(deposit => (
        <DepositsTableRow {...deposit} key={deposit.id} />
      ))}
    </>
  );
};
